import { HTTP } from '@/http'
// initial state
const state = {
  incomes: {},
  incomesPreloader: true,
  dateFrom: '',
  dateTo: ''
}
// mutations
const mutations = {
  setIncomes: function(state, value) {
    state.incomes = { ...state.incomes, ...value }
  },
  setIncomesPreloaderState: function(state, value) {
    state.incomesPreloader = value
  },
  setDateFrom: function (state, date) {
    state.dateFrom = date
  },
  setDateTo: function (state, date) {
    state.dateTo = date
  }
}
// actions
const actions = {
    async updateIncomes(context, params) {
    let access = context.rootGetters.chechAccess('charges')
    if (!access) {
      context.commit('setIncomesPreloaderState', false)
      return false
    }
    // let d = new Date()
    let defaultParams = {
      DatePartType: '',
      PeriodStart: '',
      PeriodEnd: '',
      dashboard: false,
    }
    params = { ...defaultParams, ...params }

    context.commit('setIncomesPreloaderState', true)

    let incomes = {}
     await HTTP.post('/api/get-incomes', params)
      .then(response => {
        // if (response.status === 200) context.commit('setIncomes', response.data)
        if (response.status === 200) {
          incomes = {...incomes, ...response.data}
          context.commit('setIncomes', incomes)
          context.commit('setIncomesPreloaderState', false)
        }
      })
      .catch(e => {
        this.errorMessage = e
        this.dispatch('errorProcess', e)
      })
    context.commit('setIncomesPreloaderState', false)


  },
}
// getters
const getters = {
  getIncomes(state) {
    return state.incomes
  },
  getIncomesPreloader(state) {
    return state.incomesPreloader
  },
  getDateFrom (state) {
    return state.dateFrom
  },
  getDateTo (state) {
    return state.dateTo
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
